export const PATH_SEPARATOR = '.';
export const LABEL_SEPARATOR = ' / ';
